import React from 'react';
import { useFragment, graphql } from 'react-relay';
import AvatarGroup from '@atlaskit/avatar-group';
import { useIntl } from '@atlassian/jira-intl';
import type { reviewersCell_softwareCodePage$key } from '@atlassian/jira-relay/src/__generated__/reviewersCell_softwareCodePage.graphql';
import messages from './messages';
import { NoReviewersText } from './styled';

type reviewersCellProps = {
	reviewersCellData: reviewersCell_softwareCodePage$key;
};

const ReviewersCell = ({ reviewersCellData }: reviewersCellProps) => {
	const { formatMessage } = useIntl();
	const { reviewers } = useFragment(
		graphql`
			fragment reviewersCell_softwareCodePage on DevOpsPullRequestDetails {
				reviewers @required(action: THROW) {
					approvalStatus
					user {
						name
						picture
					}
				}
			}
		`,
		reviewersCellData,
	);

	if (!reviewers.length) {
		return <NoReviewersText>{formatMessage(messages.noReviewersMessage)}</NoReviewersText>;
	}

	// We're putting approved reviewers on the top
	const avatarGroupData = [...reviewers]
		.sort((reviewer) => (reviewer?.approvalStatus === 'APPROVED' ? -1 : 1))
		.map((reviewer, index) => ({
			key: index,
			status: reviewer?.approvalStatus === 'APPROVED' ? 'approved' : null,
			name: reviewer?.user?.name || formatMessage(messages.unknownUser),
			src: reviewer?.user?.picture || '',
		}));

	return <AvatarGroup appearance="stack" size="small" data={avatarGroupData} maxCount={3} />;
};

export { NoReviewersText };
export { messages as ReviewersCellMessages };
export default ReviewersCell;
